// src/mocks/browser.ts
import { setupWorker } from 'msw/browser';
import { handlers } from './handlers';

export const startMSW = async () => {
    if (import.meta.env.MODE !== 'development' || import.meta.env.VITE_USE_MSW !== 'true') return;
    // Start msw mock service worker

    const worker = setupWorker(...handlers);
    return worker.start();
};
